import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchUpdateKanbanTicket } from '../services/patchUpdateKanbanTicket.service';

// The API responds with the bare updated ticket; the image bookkeeping is
// assembled client-side from the request args (the client generated the
// image ids, so it knows everything about them). `silent` suppresses the
// success snackbar — used by the create flow's follow-up image PATCH.
export const updateKanbanTicket = createAsyncThunk(
  'kanban/updateKanbanTicket',
  async ({ projectId, ticketId, updates, imagesToAdd = [], imagesToDelete = [] }) => {
    const updatedTicket = await patchUpdateKanbanTicket(
      projectId,
      ticketId,
      updates,
      imagesToAdd,
      imagesToDelete
    );
    const now = new Date().toISOString();
    return {
      updatedTicket,
      addedImages: imagesToAdd.map((image) => ({
        ...image,
        ticketId,
        projectId,
        type: 'KANBAN_TICKET_IMAGE',
        createdAt: now,
      })),
      deletedImageIds: imagesToDelete,
    };
  }
);
